var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var Dialog_1 = __importDefault(require("./Dialog"));
exports.Dialog = Dialog_1.default;
exports.default = Dialog_1.default;
//# sourceMappingURL=index.js.map